import { MessageType } from "../../Constant";
import { setTokenExpired } from "../actions/authActions";
import { setNotificationMessage } from "../actions/notificationAction";
import {
  fetchVehicleList,
  refreshUplift,
  updateBorneByService,
} from "../../services/contractService";
import {
  subscriptionPlanDetails,
  updateRefreshUpliftStatus,
  vehicleListFetched,
} from "../actions/contractedVehicleAction";
import { createAllActionCreators } from "./actionCreatorUtil";
import { hideLoading } from "../../shared/widgets";

export const refreshUpliftAction = () => (dispatch) => {
  dispatch(updateRefreshUpliftStatus("Data Sync In Process"));
  refreshUplift()
    .then(() => {
      dispatch(updateRefreshUpliftStatus(""));
    })
    .catch((err) => {
      if (err.message.includes("Invalid token")) {
        dispatch(setTokenExpired(true));
      } else {
        dispatch(
          setNotificationMessage({
            type: MessageType.ERROR,
            message: err.message ? err.message : "Something went wrong",
          }),
        );
      }
    });
};

const contractedActionCreators = {

  fetchVehicleListAction: {
    service: fetchVehicleList,
    action: vehicleListFetched,
  },
  updateBorneByAction: {
    service: updateBorneByService,
    responseFn: async (response, responseParams) => {
      const { dispatch, loaderType = "header", params: { handleBorneBy } } = responseParams;
      if (response && response.code === 500) {
        throw response;
      }
      dispatch(subscriptionPlanDetails(response));
      handleBorneBy(true);
      dispatch(hideLoading(loaderType));
    },

    errorFn: (err, errorParams) => {
      const { dispatch, loaderType = "header", params: { handleBorneBy } } = errorParams;
      if (err.message.includes("Invalid token")) {
        dispatch(setTokenExpired(true));
      } else {
        dispatch(
          setNotificationMessage({
            type: MessageType.ERROR,
            message: err.message || "Something went wrong",
          }),
        );
      }
      handleBorneBy(false);
      dispatch(hideLoading(loaderType));
    },
  },
};

export const { updateBorneByAction, fetchVehicleListAction } = createAllActionCreators(
  contractedActionCreators,
);
